<template>
  <div class="connect">
    <div class="ico">
      <img :src="require('@/assets/svg/device.svg')" alt="" />
    </div>
    <div class="ico">
      <img :src="require('@/assets/svg/watch.svg')" alt="" />
    </div>
    <div class="ico">
      <img :src="require('@/assets/svg/bank.svg')" alt="" />
    </div>
    <div class="ico">
      <img :src="require('@/assets/svg/card.svg')" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseConnect.vue"
};
</script>

<style lang="scss" scoped>
.connect {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  img {
    align-self: center;
  }
}
</style>
